import { deleteRequest, get, patch, post } from "./api";

export const getTranscripts = (customerId, page, PAGE_SIZE) => {
  return get(
    `/api/v2/customers/${customerId}/transcripts/?page=${page}&page_size=${PAGE_SIZE}`,
    {},
    false,
    null,
    true
  );
};

export const postTranscripts = (customerId, newTranscript) => {
  return post(`/api/v2/customers/${customerId}/transcripts/`, newTranscript);
};

export const patchTranscripts = (customerId, id, updatedFields) => {
  return patch(
    `/api/v2/customers/${customerId}/transcripts/${id}/`,
    updatedFields
  );
};

export const delTranscripts = (customerId, id) => {
  return deleteRequest(`/api/v2/customers/${customerId}/transcripts/${id}/`);
};
